import moment from "moment";

const EXTENSION_SRC_TYPES = {
  PDF: "application/pdf",
  JPG: "image/jpeg",
  JPEG: "image/jpeg",
  PNG: "image/png",
};

export function getPrescriptionSrcType(fileName) {
  const extension = fileName?.split(".").pop()?.toUpperCase();
  return EXTENSION_SRC_TYPES[extension] || "application/pdf";
}

export function convertUTCDate(date, format) {
  if (!format) {
    format = "MM/DD/YYYY";
  }

  const localDate = moment.utc(date).local();

  return localDate.format(format);
}
export function convertFormat(date, format) {
  if (!format) {
    format = "MM/DD/YYYY";
  }
  const localDate = moment(date);

  return localDate.format(format);
}

export function getSlaName(timeslab) {
  return timeslab == 1
    ? "0 - 12 Hours"
    : timeslab == 2
      ? "12 - 24 Hours"
      : timeslab == 3
        ? "24 - 36 Hours"
        : timeslab == 4
          ? "36 - 48 Hours"
          : timeslab == 5
            ? "48 - 60 Hours"
            : timeslab == 6
              ? "60 - 72 Hours"
              : timeslab == 7
                ? "72 Hrs - 1 Week"
                : timeslab == 8
                  ? "Cannot be supplied"
                  : "";
}
export function convertAmountToWords(n) {
  const a = [
    "",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];

  const b = [
    "",
    "",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ];

  const g = [
    "",
    "Thousand",
    "Million",
    "Billion",
    "Trillion",
    "Quadrillion",
    "Quintillion",
    "Sextillion",
    "Septillion",
    "Octillion",
    "Nonillion",
  ];

  const isEmpty = (xs) => xs.length === 0;
  const take = (n) => (xs) => xs.slice(0, n);
  const drop = (n) => (xs) => xs.slice(n);
  const reverse = (xs) => xs.slice(0).reverse();
  const chunk = (n) => (xs) =>
    isEmpty(xs) ? [] : [take(n)(xs), ...chunk(n)(drop(n)(xs))];
  const comp = (f) => (g) => (x) => f(g(x));
  const not = (x) => !x;

  const makeGroup = ([ones, tens, huns]) => {
    const num = (x) => Number(x) || 0;

    return [
      num(huns) === 0 ? "" : a[huns] + " hundred ",
      num(ones) === 0 ? b[tens] : (b[tens] && b[tens] + " ") || "",
      a[10 * tens + ones] || a[ones],
    ].join("");
  };

  const thousand = (group, i) => (group === "" ? group : `${group} ${g[i]}`);

  if (typeof n === "number") return convertAmountToWords(String(n));
  if (n === "0") return "zero";

  return comp(chunk(3))(reverse)(Array.from(n))
    .map(makeGroup)
    .map(thousand)
    .filter(comp(not)(isEmpty))
    .reverse()
    .join(" ");
}

/**
 * Returns start and end dates for the current month
 * @returns {Object} Object containing start and end dates for current month
 */
export function getCurrentMonthData() {
  const now = moment();
  const startOfMonth = now.clone().startOf("month");
  const endOfMonth = now.clone().endOf("month");

  return {
    startDate: startOfMonth.format("YYYY-MM-DD"),
    endDate: endOfMonth.format("YYYY-MM-DD"),
    currentMonth: now.month(),
    monthName: now.format("MMMM"),
    year: now.year(),
  };
}

/**
 * Fixes date that might be displaying next month instead of current month
 * @param {string|Date} date
 * @param {string} format
 * @returns {string}
 */
export function fixMonthDisplay(date, format = "MM/DD/YYYY") {
  const parsedDate = moment.utc(date).utcOffset("+05:30");

  if (!parsedDate.isValid()) {
    return "";
  }

  const currentMonth = moment().utcOffset("+05:30").month();

  if (
    parsedDate.month() - currentMonth === 1 ||
    (currentMonth === 11 && parsedDate.month() === 0)
  ) {
    parsedDate.subtract(1, "month");
  }

  return parsedDate.format(format);
}
